import styled from 'styled-components';

export const ResetPasswordStatusSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .status-icon {
    margin-bottom: 32px;
  }

  .center-text {
    text-align: center;
  }
`;
